<template>
  <div :style="{height: height + 'px'}">
    <span class="spinner" />
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    height: {
      type: Number,
      default: 60
    }
  }
}
</script>


<style scoped lang="sass">
div
  width: 115px

.spinner
  width: 40px
  height: 40px
  display: inline-block
  border-width: 2px
  border-color: #f2f2f2
  border-top-color: #9a9fa7
  animation: spin 1s infinite linear
  border-radius: 100%
  border-style: solid

@keyframes spin
  100%
    transform: rotate(360deg)
</style>